import { useAPIAction, AlphabetsDraftApi } from "melco-shared-logic";

export const useFontUpload = (service: "embroidery" | "print") => {
  const [uploadFont] = useAPIAction(
    AlphabetsDraftApi,
    async (api, file: Blob) => {
      const data = await api.userAlphabetsUploadDraft({
        service,
        file,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "fonts.actions.upload",
    }
  );

  return {
    uploadFont,
  } as const;
};
